var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex-column mt-0 mb-0",attrs:{"fluid":""}},[_c('div',{staticClass:"ma-6"},[_c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"80%","tile":""}},[_c('v-card-title',[_vm._v("Help and guidance")]),_c('v-card-text',{staticClass:"text-left"},[_vm._v(" Too be implemented... ")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }